import { AuthState } from "@/domain/model/AuthState";
import { getValue } from "@/shared/RxUtil";
var Authenticated = AuthState.Authenticated;
var Unauthenticated = AuthState.Unauthenticated;
export class GetAuthStateUseCaseImpl {
    constructor(authRepository) {
        this.authRepository = authRepository;
    }
    async run() {
        const userId = await getValue(this.authRepository.userId);
        return userId ? Authenticated : Unauthenticated;
    }
}
